import * as Constants from "../../utils/constants";

export const GetHideTAbBar = (payload: any) => ({
  type: Constants.GET_HIDE_TAB_BAR,
  payload,
});

export const setLoadForAssignDriver = (payload: any) => {
  return {
    type: Constants.SET_LOAD_FOR_ASSIGN_DRIVER,
    payload,
  };
};

export const removeDriverUnassignedLoad = (loadId: string) => {
  return {
    type: Constants.REMOVE_DRIVER_UNASSIGNED_LOAD,
    payload: loadId,
  };
};
